export enum TipoCancelamento {
  Cancelamento = 1,
  Recusa = 2,
  Reversao = 3,
  Outros = 4
}
